module.exports = __webpack_public_path__ + "img/user.88fbeabe.svg";